"use client";

import { useEffect, useRef, useState } from "react";
import { useRouter } from "next/router";
import { Lock } from "lucide-react";
import { useAuth } from "./AuthContext";

const ADMIN_LINKS = [
  { label: "Usuarios", path: "/admin/users" },
  { label: "Test Users", path: "/admin/test-users" },
  { label: "Relatorios", path: "/admin/reports" },
  { label: "Indicacoes", path: "/admin/referrals" },
  { label: "Audit Logs", path: "/admin/audit-logs" },
  { label: "Atividade", path: "/admin/activity" },
  { label: "Email Templates", path: "/admin/email-templates" },
  { label: "Comunicados", path: "/admin/communications" },
  { label: "Contato", path: "/admin/contact" },
];

export default function AdminButton() {
  const router = useRouter();
  const { user, logout } = useAuth();
  const [menuOpen, setMenuOpen] = useState(false);
  const menuRef = useRef(null);
  const buttonRef = useRef(null);

  useEffect(() => {
    if (!menuOpen) return;
    const handleClickOutside = (e) => {
      if (
        menuRef.current &&
        !menuRef.current.contains(e.target) &&
        buttonRef.current &&
        !buttonRef.current.contains(e.target)
      ) {
        setMenuOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [menuOpen]);

  if (user?.isAdmin !== true) return null;

  if (
    router.pathname.includes("/client") ||
    router.pathname.includes("/consultation") ||
    router.pathname.includes("/upload")
  ) {
    return null;
  }

  const isLoginOrHome = router.pathname === "/login" || router.pathname === "/";

  const handleToggle = () => setMenuOpen((prev) => !prev);

  const handleNavigate = (path) => {
    setMenuOpen(false);
    router.push(path);
  };

  const handleLogout = async () => {
    setMenuOpen(false);
    await logout();
    router.push('/login');
  };

  return (
    <>
      <button
        ref={buttonRef}
        type="button"
        onClick={handleToggle}
        className={`fixed z-[1200] flex items-center gap-2 rounded-full border border-gray-400 bg-white px-4 py-2 text-sm font-bold text-gray-800 shadow-xl transition hover:scale-105 hover:bg-gray-50 active:scale-95 focus:outline-none focus:ring-2 focus:ring-gray-400 ${isLoginOrHome ? 'bottom-6 left-6' : 'bottom-6 right-6'}`}
        aria-label="Menu Administrador"
        aria-expanded={menuOpen}
      >
        <Lock className="h-4 w-4" />
        <span>Admin</span>
      </button>

      {menuOpen && (
        <div
          ref={menuRef}
          className={`fixed z-[1199] w-56 rounded-2xl border border-gray-200 bg-white/95 p-4 shadow-2xl backdrop-blur dark:border-gray-700 dark:bg-gray-800/95 ${isLoginOrHome ? 'bottom-[5.5rem] left-6' : 'bottom-[5.5rem] right-6'}`}
        >
          <p className="mb-3 text-[10px] font-black uppercase tracking-[0.25em] text-gray-800 dark:text-gray-200 border-b pb-1 border-gray-100 dark:border-gray-700">
            Administracao
          </p>
          <div className="space-y-2 text-sm">
            {ADMIN_LINKS.map((link) => (
              <button
                key={link.path}
                type="button"
                onClick={() => handleNavigate(link.path)}
                className="w-full rounded-lg border border-gray-200 dark:border-gray-600 px-3 py-2 text-left font-semibold text-gray-600 dark:text-gray-300 transition hover:border-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700"
              >
                {link.label}
              </button>
            ))}
          </div>
          <div className="my-2 border-t border-gray-100 dark:border-gray-700" />
          <div className="space-y-2 text-sm">
            <button
              type="button"
              onClick={() => { setMenuOpen(false); router.push('/home'); }}
              className="w-full rounded-lg border border-gray-200 dark:border-gray-600 px-3 py-2 text-left font-semibold text-gray-600 dark:text-gray-300 transition hover:border-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700"
            >
              Voltar à Plataforma
            </button>
            <button
              type="button"
              onClick={handleLogout}
              className="w-full rounded-lg border border-red-200 dark:border-red-800 px-3 py-2 text-left font-semibold text-red-600 dark:text-red-400 transition hover:border-red-300 hover:bg-red-50 dark:hover:bg-red-900/30"
            >
              Sair
            </button>
          </div>
        </div>
      )}
    </>
  );
}
